import Settings from 'modules/Admin/settings/Settings'

function SettingsPage() {
  return (
    <div data-testid="settingsPage">
      <Settings />
    </div>
  )
}

export default SettingsPage
